import { ApplicationConfig } from '@angular/core';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalGuardConfiguration,
  MsalInterceptorConfiguration,
  MsalService,
} from '@azure/msal-angular';

import {
  InteractionType,
  PublicClientApplication,
  BrowserCacheLocation,
} from '@azure/msal-browser';

import { environment } from './environments/environment';

function MSALInstanceFactory() {
  return new PublicClientApplication({
    auth: {
      clientId: environment.auth.msal.auth.clientId,
      authority: environment.auth.msal.auth.authority,
      redirectUri: environment.auth.msal.auth.redirectUri,
      postLogoutRedirectUri: environment.auth.msal.auth.postLogoutRedirectUri,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie:
        environment.auth.msal.cache.storeAuthStateInCookie,
    },
    system: {
      allowRedirectInIframe: false,
    },
  });
}

function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: new Map(),
  };
}

function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: environment.apiConfig.scopes,
    },
  };
}

export const msalAppConfig: ApplicationConfig = {
  providers: [
    { provide: MSAL_INSTANCE, useFactory: MSALInstanceFactory },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },
    { provide: MSAL_GUARD_CONFIG, useFactory: MSALGuardConfigFactory },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
  ],
};
